import React from 'react';

const Omega3PlanCard = ({
  plan,
  isSelected,
  hasDiscount,
  savePercent,
  planBase,
  renderPrice,
  onSelect,
  getPerDay,
  t,
}) => (
  <div
    onClick={() => onSelect(plan.id)}
    className={`t-cursor-pointer t-rounded-xl t-border-2 t-transition-all ${
      isSelected
        ? 't-border-quiz-teal t-bg-teal-bg t-shadow-[0_0_0_1px_#116D6E]'
        : 't-border-g200 t-bg-white hover:t-border-quiz-teal'
    }`}
  >
    <div className="t-flex t-items-center t-justify-between t-gap-3 t-p-[18px] t-pb-[18px]">
      <div className="t-flex t-min-w-0 t-flex-1 t-items-center t-gap-3">
        <div
          className={`t-flex t-h-5 t-w-5 t-flex-none t-items-center t-justify-center t-rounded-full t-border-2 t-transition-all ${
            isSelected ? 't-border-quiz-teal t-bg-quiz-teal' : 't-border-g200 t-bg-white'
          }`}
        >
          {isSelected && <span className="t-h-2 t-w-2 t-rounded-full t-bg-white" />}
        </div>
        <div className="t-flex t-flex-wrap t-items-center t-gap-1.5">
          <span className="t-text-[15px] t-font-bold t-text-navy">{t(plan.titleKey)}</span>
          <span className="t-rounded-full t-bg-navy t-px-2.5 t-py-0.5 t-text-[10px] t-font-bold t-text-white">
            {t(plan.badgeKey)}
          </span>
          {hasDiscount && (
            <span className="t-rounded-full t-bg-quiz-teal t-px-2.5 t-py-0.5 t-text-[10px] t-font-bold t-text-white">
              -{savePercent}%
            </span>
          )}
        </div>
      </div>

      <div className="t-flex-shrink-0 t-text-right">
        <div className="t-flex t-items-baseline t-justify-end t-gap-1">
          {hasDiscount && <span className="t-text-[13px] t-text-g500 t-line-through">{renderPrice(planBase)}</span>}
          <span className="t-text-[22px] t-font-bold t-text-navy">{renderPrice(plan.amount)}</span>
        </div>
        <p className="!t-m-0 t-text-[12px] t-text-g500">
          {renderPrice(plan.perMonthAmount)} /{t('Omega3_Purchase_PerMonth')}
        </p>
      </div>
    </div>

    {isSelected && (
      <div className="t-mx-[18px] t-mb-[18px] t-flex t-flex-col t-gap-2 t-border-t t-border-teal-mid t-pt-3.5">
        <div className="t-flex t-items-center t-justify-between t-text-[13px]">
          <span className="t-flex t-items-center t-gap-1.5 t-text-gray-900">
            <span className="t-font-bold t-text-quiz-teal">✓</span>
            {t(plan.quantityLabelKey)}
          </span>
          <span className="t-rounded t-border t-border-g200 t-px-2 t-py-0.5 t-text-[12px] t-text-g500">
            {getPerDay(plan)}€/{t('Omega3_Cta_PerDay')}
          </span>
        </div>
        <div className="t-flex t-items-center t-gap-1.5 t-text-[13px] t-text-gray-900">
          <span className="t-font-bold t-text-quiz-teal">✓</span>
          {t(plan.detailKeys[1])}
        </div>
        <div className="t-flex t-items-center t-gap-1.5 t-text-[13px] t-text-gray-900">
          <span>🎁</span>
          <span className="t-font-bold t-uppercase">{t(plan.detailKeys[2])}</span>
        </div>
      </div>
    )}
  </div>
);

export default Omega3PlanCard;
